import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) { toast.success("Welcome back."); nav("/dashboard"); }
    else setErr(res.error);
  };

  return <AuthShell title="Sign in" testid="login-page">
    <form onSubmit={submit} className="space-y-4" data-testid="login-form">
      <Input label="Email" type="email" value={email} onChange={setEmail} testid="login-email" />
      <Input label="Password" type="password" value={password} onChange={setPassword} testid="login-password" />
      {err && <div className="text-sm text-red-400" data-testid="login-error">{err}</div>}
      <button disabled={busy} data-testid="login-submit" className="w-full btn-mint py-3.5 rounded-md text-sm">
        {busy ? "Signing in…" : "Sign in"}
      </button>
      <div className="text-sm text-gray-400 text-center">
        New here? <Link to="/register" className="text-[#00FFC2] hover:underline">Create an account</Link>
      </div>
    </form>
  </AuthShell>;
}

export function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const res = await register(form.email, form.password, form.name);
    setBusy(false);
    if (res.ok) { toast.success("Welcome to the Forge."); nav("/dashboard"); }
    else setErr(res.error);
  };

  return <AuthShell title="Create your account" testid="register-page">
    <form onSubmit={submit} className="space-y-4" data-testid="register-form">
      <Input label="Name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="register-name" />
      <Input label="Email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="register-email" />
      <Input label="Password" type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} testid="register-password" />
      {err && <div className="text-sm text-red-400" data-testid="register-error">{err}</div>}
      <button disabled={busy} data-testid="register-submit" className="w-full btn-mint py-3.5 rounded-md text-sm">
        {busy ? "Creating…" : "Create account"}
      </button>
      <div className="text-sm text-gray-400 text-center">
        Already have an account? <Link to="/login" className="text-[#00FFC2] hover:underline">Sign in</Link>
      </div>
    </form>
  </AuthShell>;
}

function AuthShell({ children, title, testid }) {
  return (
    <div className="min-h-[80vh] grid place-items-center px-6 py-16" data-testid={testid}>
      <div className="w-full max-w-md">
        <div className="label-eyebrow mb-3 text-center">AI Creator OS · Access</div>
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight font-display-ai text-center mb-8">
          {title}
        </h1>
        <div className="glass rounded-2xl p-7">{children}</div>
      </div>
    </div>
  );
}

function Input({ label, type = "text", value, onChange, testid }) {
  return (
    <div>
      <label className="text-xs text-gray-400 mb-1.5 block">{label}</label>
      <input
        type={type}
        required
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="w-full bg-black/40 border hairline rounded-md px-4 py-3 text-sm focus:outline-none focus:border-[#00FFC2]/60"
      />
    </div>
  );
}
